import image1 from '@/assets/images/news/detail/20200827/1.jpg';
import image2 from '@/assets/images/news/detail/20200827/2.jpg';
import image3 from '@/assets/images/news/detail/20200827/3.jpg';
import image4 from '@/assets/images/news/detail/20200827/4.jpg';
import image5 from '@/assets/images/news/detail/20200827/5.jpg';
import image6 from '@/assets/images/news/detail/20200827/6.jpg';
import image7 from '@/assets/images/news/detail/20200827/7.jpg';
import image8 from '@/assets/images/news/detail/20200827/8.jpg';
import image9 from '@/assets/images/news/detail/20200827/9.jpg';
import image10 from '@/assets/images/news/detail/20200827/10.jpg';

export default {
  id: '20200827', //  模块 id
  title: '咚小记现场|探访叮咚直播间', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '在叮咚买菜APP主页上，一个跳动的“小电视”浮标引人注目，这里正是叮咚买菜直播频道的入口。上海地区的伙伴们在工作日早8:00就可进入直播间，能看到不同的直播节目在进行。小清新的厨房场景，精致的品类摆台，身着叮咚卡通形象文化衫的主播们滔滔不绝，互动评论区热闹不已，都让人饶有兴趣地停留观看。作为新兴的营销交互模式，叮咚直播项目究竟是怎样运作的？除了台前日渐熟络的主播，背后又有哪些小伙伴们在默默付出？带着好奇之心，咚小记来到了位于军工路的叮咚直播间一探究竟。',
      isIndent: false,
    },
    // 添加空行
    {
      type: 2,
    },
    {
      type: 0,
      text: '直播间初印象',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '酷暑时节，军工路厂区内绿意正浓，叮咚直播间就位于这里的8号楼，那是一座红砖厂房式建筑，粗犷而怀旧。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '掀开大门内侧的遮光布，叮咚直播间本间呈现在眼前：占据C位的是带有美食节目风格的演播台和厨房操作间、三台不同机位与配置的摄像机、比人高得多的直播屏与灯光设备，两边分别是被机器与电脑包围的导播区，一张简易办公桌和一间隔断化妆间，项目组同事们就在各自的岗位上忙碌着，有人在写策划，有人在做拍摄方案，有人在梳理现场……当天下午没有直播，直播间里显得稍许安静，但琳琅的设备与物件，还是能让人直观地感受到这里的紧张与忙碌……',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text: '从0到1搭建直播团队',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '围绕一日三餐的餐桌文化不断深挖用户需求，打造一个具有叮咚特色的直播平台正当此时。不过，在接到项目任命的时候，叮咚直播还只是一个美好构想，摆在项目负责人面前的，首先是“人”的挑战，没有人有做直播的经验，团队如何搭建？场地设备如何选定？节目内容如何制作？等等，一切都得从0开始。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '炮火猛，反应快，只一个字“干”就是了。很快，5月28日，一个涵盖项目管理、内容创意、节目策划、导演摄制和产品运营的早期直播团队——“小皮匠”团队成立了！“小皮匠们”都是来自叮咚不同部门的同事，同样没有直播经验，但各有所长，充满热情，敢想敢为。集结后的第三天，“小皮匠”们就在盐城基地完成了一次西瓜直播，取得不错的反响。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text: '6月1日，叮咚直播项目组正式成立。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '直播项目从无到有仅用了一周的时间，展示了铁军速度。项目组成立后，筹备直播资质资料，策划首播内容，完善小程序功能运用，设计制作，选择MCN公司……大家齐心协力攻克一个又一个项目节点、难点，6月16日，成功完成叮咚值播间的首播。',
      isIndent: false,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text: '与直播共成长',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '《实惠早知道》、《今天吃什么》、《情调小食光》、《周末吃好点》是叮咚直播项目打造的特色全天候联播节目，从策划、摄制到主播等都由项目组同事们亲自担纲。小记了解到，生鲜电商界的不少同行也开启了直播带货营销模式，但目前只有叮咚直播团队把打造全天候的直播节目作为目标，只为加深用户消费体验，让美好的食材为更多人发现。做直播，也许叮咚er不是最有经验的，但一定是最踏实的，正是这样的确定性和坚持让叮咚直播收获了一批铁粉。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text:
        '叮咚主播团队在直播中承担着重要角色，他们中的很多人在加入叮咚以前都鲜有生鲜直播经验，大家就一边学习研究、沟通请教，积累产品行业知识，一边通过直播实战总结经验。上播前，主动与节目策划沟通确认细节，下播后，主动开展批评与自我批评，只为下次做得更好。值得一提的是，主播们还会在各自的节目里cue到其他主播，融洽的氛围在潜移默化中传递着团队目标的一致。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text:
        '工作日上午有两档直播节目进行，中间只有45分钟间隔，是直播间最紧张忙碌的时候。自7月17日搬迁到军工路来，项目组小伙伴们每天都是7点就到达直播间做准备。这里的节奏很快，要求每个人都必须快速反应，什么时间点摆台、化妆、上播、发优惠券或产品弹窗都是细化到分分秒秒的工作，非常严谨，环环相扣，不容出错。晚上，他们也常常顶着深深的夜色走出直播间，在与大家的交谈中，我们被他们对于这份工作的热情、专注和投入所触动。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 0,
      text:
        '直播项目组的微盘里，记录了团队小伙伴们工作内外的不少花絮照片，并精心搭配了文字，大家是想用这样的方式记录每一个人与直播项目一起成长的点点滴滴。逐一翻阅这些照片，那些不去抓拍就稍纵即逝的微表情，那些专注工作的背影，那些激烈讨论的侧颜，都让人感觉到这支新生的直播团队，他们眼里，有光！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 1,
      title: '',
      src: [image9, image10],
    },
  ],
};
